export default __webpack_public_path__ + "media/images/ui-bg_glass_65_ffffff_1x400-ed31481b45167e6f49fdcb1499911bf3.png";